// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__sZBot","colMin":"styles_colMin__1MyzL","colCheckbox":"styles_colCheckbox__3mzY1"};